import type { DSDealsPage } from 'shared-definitions/types'
import type { ApiResponse, ApiDealsPageProps } from 'data-source/types.wp'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import { dealsPageDataMapper } from 'data-source/mappers/dealsPageDataMapper'

interface CodecGetDealsPage extends MetaMapperOpts {
  pagePath: string
}
export function codecGetDealsPage(
  raw: ApiResponse<ApiDealsPageProps>,
  opts: CodecGetDealsPage
): DSDealsPage {
  const input = raw.data
  return {
    head: { metaTitle: 'Deals', metaTags: [], jsonLd: [] },
    meta: metaMapper({ ...input, content: {} }, ['Deals'], opts),
    ampPagePath: null,
    pagePath: opts.pagePath,
    sections: null,
    resource: 'deals-page',
    ...dealsPageDataMapper(input, opts),
  }
}
